export default "__VITE_PUBLIC_ASSET__29cfac1a__"